import React from 'react';
import { Link } from 'react-router-dom';
import { HOME_SEO_FAQ } from '../../data/seoHomeFaq';
import './HomeStructuredContent.css';

const HomeStructuredContent = ({ darkMode }) => {
  const mode = darkMode ? 'dark' : 'light';

  return (
    <div className={`home-corporate ${mode}`}>
      <div className="home-corporate__inner">
        {/* Retos: rejilla tipo homepage empresa, no artículo largo */}
        <section className="home-corporate-section" aria-labelledby="hc-retos">
          <header className="home-corporate-head">
            <h2 id="hc-retos">Situaciones típicas antes de poner orden</h2>
            <p className="home-corporate-lead">
              Cuatro retos que repetimos en consultoría cuando toca ordenar ERP,
              datos e integraciones.
            </p>
          </header>
          <div className="home-corporate-grid home-corporate-grid--4">
            <article className="home-corporate-card">
              <span className="home-corporate-card__label">Gestión</span>
              <h3 className="home-corporate-card__title">Excel ya no da más de sí</h3>
              <p className="home-corporate-card__text">
                Versiones distintas del mismo dato entre almacén y administración.
                Hace falta <strong>software de gestión</strong> con una sola verdad.
              </p>
            </article>
            <article className="home-corporate-card">
              <span className="home-corporate-card__label">Sistemas</span>
              <h3 className="home-corporate-card__title">Herramientas desconectadas</h3>
              <p className="home-corporate-card__text">
                CRM, facturación y tienda online cuentan cifras distintas en la misma reunión.
                Ahí entra la <strong>integración de sistemas</strong>.
              </p>
            </article>
            <article className="home-corporate-card">
              <span className="home-corporate-card__label">ONG</span>
              <h3 className="home-corporate-card__title">Poca trazabilidad, mucho papeleo</h3>
              <p className="home-corporate-card__text">
                Proyectos sociales y expedientes en carpetas y correos. Orden para rendir cuentas sin frenar el trabajo social.
              </p>
            </article>
            <article className="home-corporate-card">
              <span className="home-corporate-card__label">Proceso</span>
              <h3 className="home-corporate-card__title">El software no refleja cómo trabajas</h3>
              <p className="home-corporate-card__text">
                Si el equipo salta el ERP, el problema no es “motivación”: hay que
                adaptar flujos, permisos o integraciones.
              </p>
            </article>
          </div>
        </section>

        {/* Audiencia: dos bloques grandes */}
        <section className="home-corporate-section" aria-labelledby="hc-audiencia">
          <header className="home-corporate-head">
            <h2 id="hc-audiencia">Con quién trabajamos</h2>
          </header>
          <div className="home-corporate-grid home-corporate-grid--2">
            <article className="home-corporate-block">
              <h3 className="home-corporate-block__title">Pymes en crecimiento</h3>
              <p className="home-corporate-block__text">
                Más pedidos y más gente: cuando la gestión va a remojo, el cuello de botella
                es estratégico. Un <Link to="/erp-para-pymes">ERP para pymes</Link> bien planteado
                suele ir acompañado de integración o automatización.
              </p>
            </article>
            <article className="home-corporate-block">
              <h3 className="home-corporate-block__title">ONG y entidades sociales</h3>
              <p className="home-corporate-block__text">
                Menos tiempo en informes duplicados y más en personas y programas.
                <Link to="/erp-para-ong"> Software de gestión para ONG</Link>
                {' '}y <Link to="/tercer-sector">tercer sector</Link>.
              </p>
            </article>
          </div>
        </section>

        {/* Cómo: franja compacta */}
        <section className="home-corporate-strip" aria-labelledby="hc-proceso">
          <h2 id="hc-proceso" className="home-corporate-strip__title">
            Cómo trabajamos
          </h2>
          <ul className="home-corporate-strip__list">
            <li><strong>Diagnóstico</strong> claro</li>
            <li><strong>Fases</strong> que puedes usar en producción</li>
            <li><strong>Formación</strong> a quien opera el sistema</li>
            <li><strong>Seguimiento</strong>, sin desaparecer tras el alta</li>
          </ul>
        </section>

        {/* Vulpin: bloque destacado producto */}
        <section className="home-corporate-spotlight" aria-labelledby="hc-vulpin">
          <div className="home-corporate-spotlight__text">
            <h2 id="hc-vulpin">Nuestro ERP modular: Vulpin Suite</h2>
            <p>
              También desarrollamos y mantenemos{' '}
              <Link to="/vulpin" className="vulpin-inline-link">
                Vulpin Suite
              </Link>
              : <strong>Business</strong> (pymes), <strong>Social</strong> (ONG),{' '}
              <strong>Care</strong> (centros) y <strong>Corps</strong> (voluntariado).
              No es la única herramienta con la que trabajamos; es la prueba de que
              implantamos software real.
            </p>
            <p className="home-corporate-spotlight__muted">
              Si encaja, vamos más rápido. Si no encaja, no te lo colamos: integramos lo que ya tienes.
            </p>
          </div>
          <div className="home-corporate-spotlight__cta">
            <Link to="/vulpin" className="home-corporate-spotlight__btn">
              Ver Vulpin Suite
            </Link>
          </div>
        </section>

        {/* Casos */}
        <section className="home-corporate-section" aria-labelledby="hc-casos">
          <header className="home-corporate-head">
            <h2 id="hc-casos">Tipo de proyectos que hacemos</h2>
          </header>
          <div className="home-corporate-grid home-corporate-grid--3">
            <article className="home-corporate-mini">
              <p>
                Pyme de servicios: presupuestos, albaranes y facturación con trazabilidad por cliente.
              </p>
            </article>
            <article className="home-corporate-mini">
              <p>
                Administración que dejó de pasar pedidos del CRM al ERP a mano gracias a integración y reglas.
              </p>
            </article>
            <article className="home-corporate-mini">
              <p>
                Entidad social con expedientes y proyectos listos para informes a patrocinadores.
              </p>
            </article>
          </div>
          <p className="home-corporate-footnote">
            No publicamos nombres sin permiso; en conversación te contamos casos parecidos al tuyo.
          </p>
        </section>

        {/* FAQ */}
        <section className="home-corporate-faq" aria-labelledby="hc-faq">
          <header className="home-corporate-head home-corporate-head--center">
            <h2 id="hc-faq">Preguntas frecuentes</h2>
          </header>
          <div className="home-corporate-faq__list">
            {HOME_SEO_FAQ.map((item) => (
              <details key={item.question} className="home-corporate-faq__item">
                <summary>{item.question}</summary>
                <p>{item.answer}</p>
              </details>
            ))}
          </div>
        </section>

        <div className="home-corporate-cta-wrap">
          <Link to="/contacto" className="home-corporate-cta">
            Revisar mi caso
          </Link>
        </div>
      </div>
    </div>
  );
};

export default HomeStructuredContent;
